import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { message, Modal } from 'antd';

import { UserForApproveUser } from '../../graphql/users';
// import { getOrgByID } from '../../graphql';
import { queryCageDetails, queryNiinDetails, queryToolingComments, mutationToolingComment } from './graphql';
import createRFQ from '../../graphql/sendRFQ';

import history from '../../config/history';

export default function UniversalDetailsHOC(UniversalDetailsPage) {

  class WrappedComponent extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
      auth: PropTypes.instanceOf(Object).isRequired,
      // udHistory: PropTypes.object.isRequired,
    };

    static initialState = {
      cageData: {},
      niinData: {},
      udHistory: {},
      // data: {},
      isLoading: true,
      // modalRfqOpen: false,
      modalProcGroupVisible: false,
      // showSendRfq: false,
      rfqInput: {
        participants: null,
        niin: null,
        partNum: null,
        partDesc: null,
        drawingNums: null,
      },
    };

    /* ---------------------------------------
      TRANSFORM DATE FILTER PARAMS
    -----------------------------------------*/
    state = WrappedComponent.initialState;

    /* ----------------------------------
      LIFECYCLE - COMPONENT DID MOUNT
    -------------------------------------*/
    async componentDidMount() {
      // fake graphql
      const id = this.props.auth.id;

      const location = this.props.location;
      let cage = null;
      let niin = null;
      let partNum = null;

      if (location.search) {
        const params = new URLSearchParams(location.search);
        cage = params.get('cage');
        niin = params.get('niin');
        partNum = params.get('partnum');

        let cageData
        if (cage) {
          cageData = await queryCageDetails(id, cage);
          this.setState({
            cageData: cageData.queryCageDetails,
            isLoading: false,
          });
        }

        let niinData
        if (niin) {
          niinData = await queryNiinDetails(id, niin);
          this.setState({
            niinData: niinData.queryNiinDetails,
            isLoading: false,
          });
        }

        const udHistory = sessionStorage.udHistory ? JSON.parse(sessionStorage.udHistory) : null
        this.setState({
          udHistory
        });

        const partDescrFromTooling = udHistory && udHistory.toolingSearch && udHistory.toolingSearch[0] ? udHistory.toolingSearch[0].description : null;
        const partDescrFromProcurement = niinData && niinData.queryNiinDetails && niinData.queryNiinDetails.itemDetails && niinData.queryNiinDetails.itemDetails[0] ? niinData.queryNiinDetails.itemDetails[0].nomenclature : null;

        this.setState({
          rfqInput: {
            participants: [cage],
            niin,
            partNum,
            partDesc: partDescrFromTooling || partDescrFromProcurement,
          }
        });

        console.log("auth", this.props.auth)
        if (cage && partNum && (this.props.auth.role === "GOVERNMENT_USER" || this.props.auth.role === "SUPER_ADMIN")) {
          const toolingCommentsList = await queryToolingComments(cage, partNum, niin);
          this.setState(prevState => ({
            cageData: {
              ...prevState.cageData,
              toolingCommentsGov: toolingCommentsList.queryToolingComments.toolingCommentsGovList
            }
          }))
        }

        // if (cage && niin && partNum) {
        //   this.setState({
        //     showSendRfq: true,
        //   });
        // }

        if (document.getElementById("btn-tool-comment-add")) {
          if (params.get('imgClick') === 'Y') {
            document.getElementById("btn-tool-comment-add").scrollIntoView({ behavior: "smooth" });
          }
        }
      }
    }

    _addToolinCommentGov = async () => {
      const resp = await UserForApproveUser(this.props.auth.id)
      const commentTxt = document.getElementById("tooling-gov-comment");
      if (this.props.auth.role === 'GOVERNMENT_USER' || this.props.auth.role === 'SUPER_ADMIN') {
        if (commentTxt.value.length >= 6 && commentTxt.value.length < 1000) {
          const location = this.props.location;
          const params = new URLSearchParams(location.search);
          // const postBody = {
          //   cage: params.get('cage'),
          //   partNum: params.get('partnum'),
          //   niin: params.get('niin'),
          //   email: resp.user.email,
          //   comment: commentTxt.value
          // }
          const cage = params.get('cage')
          const partNum = params.get('partnum')
          const niin = params.get('niin')
          const email = resp.user.email
          const comment = commentTxt.value
          await mutationToolingComment(cage, partNum, email, comment, niin)
            .then((res) => {
              console.log('res-addtool-comment-gov => ', res);
              this.componentDidMount();
            }).catch((err) => {
              console.error({ msg: 'Error Calling /unified-details/add-tooling-comment service!' }, err);
            });
        } else {
          message.info("Comment must be between 6 and 1000 characters long");
        }
      } else {
        message.warn("Only Admins and Government Users can add DLA Comments!");
      }
    }

    sendRFQ = async () => {
      const cageCode = this.props.auth.cageCode
      // const org = await getOrgByID(this.props.auth.organizationId);
      if (this.props.auth.permissions && this.props.auth.permissions.includes(1)) {
        this.saveRfq()
      } else {
        if (cageCode.startsWith('OG')) {
          message.warn({
            content: 'Currently you do not have permissions to use Send RFQ but you can enable it by updating you user profile and relogin.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        } else if (!cageCode.startsWith('OG') && cageCode.startsWith('O')) {
          this.setState({
            modalProcGroupVisible: true,
          })
        } else {
          message.warn({
            content: 'Your account does not have permission to submit RFQs, your organization administrator can enable this permission in your user profile.',
            style: {
              marginTop: '10vh',
            },
          }, 6);
        }
      }
    };
    saveRfq = async () => {
      const res = await createRFQ(this.props.auth.id, this.state.rfqInput);
      const { status } = res;
      if (status !== 'success') {
        // TODO: error Handling
        message.error(
          'Oops, Something Went Wrong While Saving the Quote, Please Try Again and If Problem Persists Contact Support',
        );
      }

      history.push(`/contractcenter/rfq?rfq=${res.rfqId}`);
    };

    // closeRfqModal = () => {
    //   this.setState({ modalRfqOpen: false });
    // };
    closeProcGroupModal = () => {
      this.setState({ modalProcGroupVisible: false });
    };

    /* ----------------------------------
      RENDER
      -------------------------------------*/
    render() {
      // const { niinData, cageData, data, isLoading, modalRfqOpen, modalProcGroupVisible, rfqInput } = this.state;
      const { niinData, cageData, udHistory, isLoading, modalProcGroupVisible } = this.state;
      const { auth } = this.props;
      const pageProps = {
        niinData,
        cageData,
        udHistory,
        auth,
        // data,
        addToolinCommentGov: this._addToolinCommentGov,
        isLoading,
        // closeRfqModal: this.closeRfqModal,
        // closeProcGroupModal: this.closeProcGroupModal,
        sendRFQ: this.sendRFQ,
        // modalRfqOpen,
        // modalProcGroupVisible,
        // rfqInput,
        // showSendRfq,

      };
      return (
        <React.Fragment>
          <div>
            <UniversalDetailsPage {...pageProps} />
          </div>
          <Modal
            visible={modalProcGroupVisible}
            title='Warning'
            type='warning'
            style={{ top: '40' }}
            onOk={this.closeProcGroupModal}
            onCancel={this.closeProcGroupModal}
          >
            Government users with RFQ Capabilities must be members of a RFQ Group to submit RFQs. Please contact < a href="mailto:support@nffs.org?Subject=Registration RFQ Group" target="_top"> ICON Support</a > to be added to a RFQ Group if you are an authorized procurement officer.
          </Modal>
        </React.Fragment>

      )
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/universalDetails/UniversalDetailsHOC.jsx